module.exports = __webpack_public_path__ + "media/packs/instagram-29e81e63329e9bc630d5a1b182f7c961.svg";